module.exports = __webpack_public_path__ + "media/images/salles de réunion-a0cc03a9506db555a7f8517837a839d0.svg";